import { createContext, useState } from "react";
import LogManagementData from "./LogManagementData";

export const LogManagementContext = createContext();
export const LogManagementContextProvider = (props) => {
    const [data, setData] = useState(LogManagementData);

    return <LogManagementContext.Provider value={{contextData: [data, setData]}}>{props.children}</LogManagementContext.Provider>
}